import React, {useState} from "react";
import {
    Typography,
    Grid,
    Paper,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {API} from "aws-amplify";
import CustomizedSnackbars from "../../components/CommonUtilities/CustomizedSnackbars";
import {openAlert, K_ALERT} from "../../components/CommonUtilities/UtilityFunctions";
import CalculateIcon from "@material-ui/icons/Assessment";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(3),
    },
    paper: {
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        marginBottom: theme.spacing(3),
    },
    buttonWrapper: {
        marginTop: theme.spacing(2),
        position: 'relative',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }
}));

export default function Configuration(props) {
    const classes = useStyles();
    const [alertStatus, setAlertStatus] = useState({open: false, message: "", severity: ""});
    const [isCalculating, setIsCalculating] = useState(false);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const calculateAveragesApi = () => {
        return API.get("misServiciosEscolares", "/students?averages=true");
    };

    const handleCalculateAverages = async () => {
        setConfirmDialogOpen(false);
        setIsCalculating(true);
        try {
            await calculateAveragesApi();
            openAlert(
                setAlertStatus,
                K_ALERT.MESSAGE.CONFIGURATION.AVERAGES_REQUEST_ACCEPTED,
                K_ALERT.SEVERITY.SUCCESS
            );
        } catch (e) {
            console.error("Error calculating averages:", e);
            openAlert(setAlertStatus);
        } finally {
            setIsCalculating(false);
        }
    };

    const handleChangeOnAlert = (shouldPresentAlert) => {
        setAlertStatus(shouldPresentAlert);
    };

    function renderConfiguration() {
        return (
            <div className={classes.root}>
                <Typography variant="h4" className={classes.title}>
                    Configuración General
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Paper className={classes.paper}>
                            <Typography variant="h6" gutterBottom>
                                Cálculo de Promedios de Estudiantes
                            </Typography>
                            <Typography variant="body2" color="textSecondary" paragraph>
                                Esta función calcula los promedios de todos los estudiantes y envía un archivo CSV por correo electrónico cuando está listo.
                                Este proceso puede tardar varios minutos dependiendo de la cantidad de estudiantes.
                            </Typography>
                            <div className={classes.buttonWrapper}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<CalculateIcon />}
                                    onClick={() => setConfirmDialogOpen(true)}
                                    disabled={isCalculating}
                                >
                                    Calcular Promedios
                                </Button>
                                {isCalculating && (
                                    <CircularProgress size={24} className={classes.buttonProgress} />
                                )}
                            </div>
                        </Paper>
                    </Grid>
                </Grid>

                {/* Confirmation Dialog */}
                <Dialog
                    open={confirmDialogOpen}
                    onClose={() => setConfirmDialogOpen(false)}
                >
                    <DialogTitle>Confirmar Cálculo de Promedios</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ¿Estás seguro que deseas iniciar el cálculo de promedios para todos los estudiantes?
                            Recibirás un correo electrónico cuando el proceso esté completo.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setConfirmDialogOpen(false)} color="default">
                            Cancelar
                        </Button>
                        <Button onClick={handleCalculateAverages} color="primary" variant="contained">
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Notification Snackbar */}
                <CustomizedSnackbars
                    status={alertStatus}
                    alertCallback={handleChangeOnAlert}
                />
            </div>
        );
    }

    return (
        <>
            {props.isAuthenticated ? renderConfiguration() : props.history.push("/login")}
        </>
    );
}
